export const HTTP_STATUS_CODES = {
  UNAUTHORIZED: 401,
};

export const ROOT_ELEMENT_ID = 'single-spa-application:@spoton/restaurant-reporting-dashboard-frontend';
